import { render } from "./ModalDocumentUploadFailed.vue?vue&type=template&id=0fe658bf&scoped=true"
import script from "./ModalDocumentUploadFailed.vue?vue&type=script&lang=js"
export * from "./ModalDocumentUploadFailed.vue?vue&type=script&lang=js"

import "./ModalDocumentUploadFailed.vue?vue&type=style&index=0&id=0fe658bf&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe658bf"]])

export default __exports__